<template>
  <div class="main">
    <HeaderVue class="head" />
    <Sidebar class="sidebar" />
    <Dashboard title="Casas"
      ><b-row class="mb-5">
        <b-col cols="12" sm="7" class="mb-2">
          <Search
            @changeSearchValue="searchValue = $event"
            searchPlaceholder="Buscar por nome ou código"
          />
        </b-col>
        <b-col>
          <b-row class="justify-content-end mr-1">
            <b-col cols="auto">
              <b-button
                variant="outline-secondary"
                @click="addNewHouse"
                class="mr-3"
              >
                <b-icon icon="plus-circle-fill"></b-icon> Adicionar
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- <div v-if="isHousesEmpty && !isSearchEmpty" class="text-center mt-3">
        Nenhuma casa ou código encontrada com a busca: {{ searchValue }}.
      </div>
      <div v-else class="text-center mt-3">Nenhuma casa cadastrada'.</div> -->
      <HousesList :houses="housesFiltered" />
    </Dashboard>
    <ModalAddHouse />
  </div>
</template>

<script>
import Dashboard from '../Dashboard.vue';
import HeaderVue from '../Header.vue';
import Sidebar from '../Sidebar.vue';
import Search from '../Search.vue';
import ModalAddHouse from './ModalAddHouse.vue';
import HousesList from './HousesList.vue';
import { Houses } from '../../services/House';
import showError from '../../utils/showError';

export default {
  components: {
    Dashboard,
    HeaderVue,
    Sidebar,
    Search,
    ModalAddHouse,
    HousesList,
  },
  data() {
    return {
      searchValue: '',
      houses: [],
    };
  },
  methods: {
    addNewHouse() {
      this.$bvModal.show('modal-add-house');
    },
    updateSearchValue(value) {
      this.searchValue = value;
    },
  },
  computed: {
    housesFiltered() {
      if (this.searchValue) {
        const searchLower = this.searchValue.toLowerCase();
        return this.houses.filter(
          (house) =>
            house.house_name.toLowerCase().includes(searchLower) ||
            house.house_code.toLowerCase().includes(searchLower)
        );
      }
      return this.houses;
    },
    isHousesEmpty() {
      return this.housesFiltered.length === 0;
    },
    isSearchEmpty() {
      return this.searchValue === '';
    },
  },
  created() {
    Houses()
      .then((res) => {
        this.houses = res.data;
      })
      .catch(showError);
  },
};
</script>

<style scoped></style>
